import { render, staticRenderFns } from "./UploadVideoSidebar.vue?vue&type=template&id=fd843a1a&scoped=true&"
import script from "./UploadVideoSidebar.vue?vue&type=script&lang=js&"
export * from "./UploadVideoSidebar.vue?vue&type=script&lang=js&"
import style0 from "./UploadVideoSidebar.vue?vue&type=style&index=0&id=fd843a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd843a1a",
  null
  
)

export default component.exports